import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from 'reactstrap';
import { useStoreActions, useStoreState } from 'easy-peasy';
import SectionTopMenu from '../../shared/components/SectionTopMenu/SectionTopMenu';
import LiveHeader from './components/LiveHeader';
import LiveFilter from './components/LiveFilter';
import LiveGallery from './components/LiveGallery';
import DownloadCategoryBundlePopup from '../../shared/components/DownloadPopup/DownloadCategoryBundlePopup';

const Live = () => {
  const {
    clientId,
    promotionId,
  } = useParams();

  const setCurrentClient = useStoreActions(actions => actions.setCurrentClient);
  const setCurrentPromotion = useStoreActions(actions => actions.setCurrentPromotion);

  setCurrentClient(clientId);
  setCurrentPromotion(promotionId);

  const currentClient = useStoreState(state => state.currentClient);
  const currentPromotion = useStoreState(state => state.currentPromotion);
  const [filters, setFilters] = useState(currentPromotion.liveFilters);
  const [currentFilter, setCurrentFilter] = useState(currentPromotion.liveFilters[0].filter);
  const [renders] = useState(currentPromotion.live.content.filter(item => item.type === 'render'));
  const [videos] = useState(currentPromotion.live.content.filter(item => item.type === 'video'));
  const [panos] = useState(currentPromotion.live.content.filter(item => item.type === 'panoramic'));
  const [orbits] = useState(currentPromotion.live.content.filter(item => item.type === 'orbit'));
  const [solarSimulators] = useState(currentPromotion.live.content.filter(item => item.type === 'solar-simulator'));
  const [configurators] = useState(currentPromotion.live.content.filter(item => item.type === 'configurator'));
  const [categoryBundles] = useState(currentPromotion.live.categoryBundles);
  const [filteredRenders, setFilteredRenders] = useState(renders.filter(item => item.category === currentFilter));
  const [filteredVideos, setFilteredVideos] = useState(videos.filter(item => item.category === currentFilter));
  const [filteredPanos, setFilteredPanos] = useState(panos.filter(item => item.category === currentFilter));
  const [filteredOrbits, setFilteredOrbits] = useState(orbits.filter(item => item.category === currentFilter));
  const [filteredSolarSimulators, setFilteredSolarSimulators] = useState(solarSimulators
    .filter(item => item.category === currentFilter));
  const [filteredConfigurators, setFilteredConfigurators] = useState(configurators
    .filter(item => item.category === currentFilter));

  const onFilterSelected = (selectedFilter) => {
    filters.forEach((filter, index) => {
      filters[index].active = filter.filter === selectedFilter;
    });

    setCurrentFilter(selectedFilter);
    setFilters(filters);

    setFilteredRenders(renders.filter(item => item.category === selectedFilter));
    setFilteredVideos(videos.filter(item => item.category === selectedFilter));
    setFilteredPanos(panos.filter(item => item.category === selectedFilter));
    setFilteredOrbits(orbits.filter(item => item.category === selectedFilter));
    setFilteredSolarSimulators(solarSimulators.filter(item => item.category === selectedFilter));
    setFilteredConfigurators(configurators.filter(item => item.category === selectedFilter));
  };

  const [downloadPopupOpened, setDownloadPopupOpened] = useState(false);

  const openDownloadPopup = (index) => {
    setDownloadPopupOpened(true);
  };

  const closeDownloadPopup = () => {
    setDownloadPopupOpened(false);
  };

  return (
    <Fragment>
      <SectionTopMenu clientName={currentClient.name} promotionName={currentPromotion.name} />
      <LiveHeader headerImage={currentPromotion.image} lastUpdate={currentPromotion.live.lastUpdate} />
      <LiveFilter filters={filters} onFilterSelected={onFilterSelected} downloadAll={openDownloadPopup} />
      <LiveGallery type="renders" items={filteredRenders} />
      <LiveGallery type="videos" items={filteredVideos} />
      <LiveGallery type="tour virtual 360" items={filteredPanos} />
      <LiveGallery type="orbita 3d" items={filteredOrbits} />
      <LiveGallery type="simulador solar" items={filteredSolarSimulators} />
      <LiveGallery type="configurador" items={filteredConfigurators} />
      <Modal
        isOpen={downloadPopupOpened}
        centered
        className="modal-full-screen"
      >
        <DownloadCategoryBundlePopup
          category={filters.find(filter => filter.filter === currentFilter).title}
          categoryBundle={categoryBundles.find(bundle => bundle.category === currentFilter)}
          onClose={closeDownloadPopup}
        />
      </Modal>
    </Fragment>
  );
};

export default Live;
